import { Plus } from 'lucide-react'

import { Button, InfoTip } from '@krp/ui-kit'

import '../../../shared/ui/aqsi.css'
import { ACCESS_WORDS, CREATE_DISABLED_REASON, PRICE_KINDS, PRICE_KINDS_HELP } from '../model/kinds'

/**
 * «Цены» кабинета AQSI — тот же список, что у 1С («Виды цен»), но с тем, что есть в кабинете: у AQSI нет справочника видов цен,
 * только фиксированный набор цен у товара. «Создать» выключено с причиной — не спрятано, чтобы было видно, чем кабинет отличается
 * от 1С. Данных с сервера нет: набор определяет API кабинета.
 */
export function PriceKindsScreen() {
  return (
    <section className="aqsi-screen" aria-labelledby="aqsi-price-kinds-title">
      <header className="aqsi-toolbar">
        <h2 id="aqsi-price-kinds-title">Виды цен кабинета</h2>
        <Button variant="primary" icon={<Plus size={14} aria-hidden="true" />} disabled>
          Создать вид цен
        </Button>
        <InfoTip label="Почему нельзя создать вид цен">{PRICE_KINDS_HELP.fixed}</InfoTip>
      </header>
      <p className="aqsi-caption" role="note">
        {CREATE_DISABLED_REASON}
      </p>
      <table className="aqsi-table">
        <caption className="aqsi-caption">Видов цен: {PRICE_KINDS.length}</caption>
        <thead>
          <tr>
            <th>Название</th>
            <th>Что это</th>
            <th>
              Что умеет наша система <InfoTip label="Что умеет наша система">{PRICE_KINDS_HELP.access}</InfoTip>
            </th>
            <th>
              Поле кабинета <InfoTip label="Поле кабинета">{PRICE_KINDS_HELP.field}</InfoTip>
            </th>
          </tr>
        </thead>
        <tbody>
          {PRICE_KINDS.map((kind) => (
            <tr key={kind.id}>
              <td data-label="Название">{kind.name}</td>
              <td data-label="Что это">{kind.meaning}</td>
              <td data-label="Что умеет наша система">{ACCESS_WORDS[kind.access]}</td>
              <td data-label="Поле кабинета">
                <code>{kind.apiField}</code>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  )
}
